import React from "react";
import { Link } from "react-router-dom";
import { Inbox, Filter, Tags, Sparkles } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

export default function LeadInbox() {
  return (
    <MarketingPage
      seo={{
        title: "Lead Inbox — One inbox for high-intent X, LinkedIn & Reddit leads",
        description:
          "Stop juggling tabs. Collavue's Lead Inbox gives you a single, scored, brand-fit feed of X (Twitter), LinkedIn, and Reddit conversations that match your ICP — filterable by source.",
        path: "/lead-inbox",
        keywords:
          "lead inbox, social lead inbox, X lead inbox, Twitter lead inbox, LinkedIn lead inbox, B2B lead aggregation, social listening inbox",
      }}
    >
      <PageHero
        eyebrow="Collavue · Lead Inbox"
        title="One inbox for every"
        italicWord="qualified lead."
        description="The Lead Inbox surfaces every X (Twitter), LinkedIn, and Reddit match in a single feed — scored, filterable by source, and ready to act on."
      >
        <Link to="/signup" className="px-6 py-3 rounded-md bg-[#0a1736] text-white font-medium hover:bg-[#1c2a4d]">
          Open your inbox
        </Link>
      </PageHero>

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { icon: Inbox, title: "Unified", body: "Every X (Twitter), LinkedIn, and Reddit lead in one timeline — filter to any one source." },
            { icon: Sparkles, title: "Scored", body: "Intent + ICP fit, 0–100." },
            { icon: Filter, title: "Filterable", body: "By keyword, persona, recency, channel." },
            { icon: Tags, title: "Tagged", body: "Auto-labels for pain, competitor, urgency." },
          ].map((s) => (
            <div key={s.title} className="rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40">
              <s.icon className="w-6 h-6 text-[#2d5bff]" />
              <h3 className="font-display text-xl text-[#0a1736] font-semibold mt-3">{s.title}</h3>
              <p className="text-[#5a6478] text-sm mt-2 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </MarketingPage>
  );
}
